"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCryptoProInstalledM = void 0;

var tslib_1 = require("tslib");

var Plugin_1 = require("@skbkontur/plugin-js/lib/Plugin");

var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var constants_1 = require("./constants");
/**
 * Хардкодим разные варинаты имён КриптоПро.
 * С параметрами контрола и так уже перегруз.
 * Эти имена не должны часто меняться
 */


var CRYPTOPRO_CSP_NAMES = ['Crypto-Pro GOST R 34.10-2001 Cryptographic Service Provider', 'Crypto-Pro GOST R 34.10-2012 Cryptographic Service Provider', 'Crypto-Pro GOST R 34.10-2012 Strong Cryptographic Service Provider'];
var log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "cryptoProUtils");
/**
 * Проверяем установлен ли криптопровайдер КриптоПро.
 * если не удалось определить есть криптоПро или нет, возращаем true,
 * т.к. ставить КриптоПро нужно только если точно знаем что его нет
 * @param plugin
 */

var isCryptoProInstalled = function isCryptoProInstalled(plugin) {
  return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var providers, error_1;
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);

          return [4
          /*yield*/
          , plugin.searchCryptoProviders(Plugin_1.CryptoProviderType.CryptoApi)];

        case 1:
          providers = _a.sent(); // Выбираем из них криптопровайдеры КриптоПро.

          return [2
          /*return*/
          , providers.some(function (provider) {
            return CRYPTOPRO_CSP_NAMES.includes(provider.name);
          })];

        case 2:
          error_1 = _a.sent();
          log.error('Search cryptoprovider error.', error_1);
          return [2
          /*return*/
          , true];

        case 3:
          return [2
          /*return*/
          ];
      }
    });
  });
};
/**
 * Мемоизированная версия checkCryptoProInstalled
 */


exports.isCryptoProInstalledM = memoize_1.default(isCryptoProInstalled);